import { removeTrailZero } from "./numberFormatting";

export const calculateTotalNominalPower = (
  individualValue: string | undefined,
  numberOfBatteries: string | undefined
) => {
  const individualValueToNumber = Number(individualValue);
  const numberOfBatteriesToNumber = Number(numberOfBatteries);

  if (!individualValueToNumber || !numberOfBatteriesToNumber) {
    return "";
  }

  const result = individualValueToNumber * numberOfBatteriesToNumber;
  return removeTrailZero(result);
};

export const calculateTotalUsableCapacity = (
  individualValue: string | undefined,
  numberOfBatteries: string | undefined
) => {
  const individualValueToNumber = Number(individualValue);
  const numberOfBatteriesToNumber = Number(numberOfBatteries);

  if (!individualValueToNumber || !numberOfBatteriesToNumber) {
    return "";
  }

  const result = individualValueToNumber * numberOfBatteriesToNumber;
  return removeTrailZero(result);
};
